export default {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
};
